import React from "react";
import { Nav, Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { useSelector } from "react-redux";
import "../dashboard.css";
import { LinkContainer } from "react-router-bootstrap";

const Side = (props) => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const role = userInfo?.role || 'user';

  return (
    <>
      {userInfo && (
        <Col md={2} className="d-none d-md-block custom-sidebar-container pr-0">
          <Nav variant="pills" className="h-100 d-none d-md-block sidebar" id="sideNav">
            <div className="sidebar-nav-group">
              {/* Common links — available to all roles */}
              <Nav.Item className="m-0">
                <LinkContainer exact to="/billing">
                  <Nav.Link><i className="fa fa-file-text mr-2"></i>TRF</Nav.Link>
                </LinkContainer>
              </Nav.Item>
              <Nav.Item className="m-0">
                <LinkContainer exact to="/bookings">
                  <Nav.Link><i className="fa fa-calendar mr-2"></i>Bookings</Nav.Link>
                </LinkContainer>
              </Nav.Item>
              <Nav.Item className="m-0">
                <LinkContainer exact to="/daily-book">
                  <Nav.Link><i className="fa fa-book mr-2"></i>Day Book</Nav.Link>
                </LinkContainer>
              </Nav.Item>
              <Nav.Item className="m-0">
                <LinkContainer exact to="/reports">
                  <Nav.Link><i className="fa fa-bar-chart mr-2"></i>Reports</Nav.Link>
                </LinkContainer>
              </Nav.Item>

              {/* Lab & Admin: Tests */}
              {(role === 'lab' || role === 'admin') && (
                <>
                  <div className="sidebar-divider"></div>
                  <Nav.Item className="m-0">
                    <LinkContainer exact to="/tests">
                      <Nav.Link><i className="fa fa-flask mr-2"></i>Manage Tests</Nav.Link>
                    </LinkContainer>
                  </Nav.Item>
                </>
              )}

              {/* Lab & Admin: Manage Users */}
              {(role === 'lab' || role === 'admin') && (
                <Nav.Item className="m-0">
                  <LinkContainer exact to="/manage-users">
                    <Nav.Link><i className="fa fa-users mr-2"></i>Manage Users</Nav.Link>
                  </LinkContainer>
                </Nav.Item>
              )}

              {/* Admin only: Manage Labs */}
              {role === 'admin' && (
                <Nav.Item className="m-0">
                  <LinkContainer exact to="/manage-labs">
                    <Nav.Link><i className="fa fa-building mr-2"></i>Manage Labs</Nav.Link>
                  </LinkContainer>
                </Nav.Item>
              )}

              {/* Settings */}
              <div className="sidebar-divider"></div>
              <Nav.Item className="m-0">
                <LinkContainer exact to="/profile">
                  <Nav.Link><i className="fa fa-cog mr-2"></i>Settings</Nav.Link>
                </LinkContainer>
              </Nav.Item>
            </div>
          </Nav>
        </Col>
      )}
    </>
  );
};

const Sidebar = withRouter(Side);
export default Sidebar;
